import { render } from "./Knowledgebase.vue?vue&type=template&id=6c3b60e0"
import script from "./Knowledgebase.vue?vue&type=script&lang=js"
export * from "./Knowledgebase.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/agradata/agradata/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__